document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-accordion-toggle-row]').forEach(function (trigger) {
    // Every accordion-toggle-row section instance emits its own copy of this
    // <script> tag, so with N instances on a page this file's top-level code
    // runs N times -- the browser caches the fetch, but still executes the
    // tag each time it appears. Without this guard, each run would attach
    // ANOTHER click listener to every instance already processed, so a
    // single click would fire activate() N times synchronously, each one
    // undoing the last (regular mode) or no-oping harmlessly (one-way mode,
    // since it already guards against re-triggering) -- making toggling
    // look completely broken.
    if (trigger.dataset.accordionToggleRowInitialized) {
      return;
    }
    trigger.dataset.accordionToggleRowInitialized = 'true';

    var ownSection = trigger.closest('.accordion-toggle-row-section');
    var shopifySection = trigger.closest('.shopify-section');

    // Best-effort aria-controls: find the actual next section's real DOM id.
    // Not required for the show/hide mechanism itself (that's CSS-only via
    // :has() in the section's generated <style> block) -- this is purely an
    // accessibility enhancement so screen readers know which element the
    // trigger controls.
    var targetSection = shopifySection ? shopifySection.nextElementSibling : null;
    if (targetSection && targetSection.classList.contains('shopify-section') && targetSection.id) {
      trigger.setAttribute('aria-controls', targetSection.id);
    }

    function activate() {
      var isOneWay = trigger.getAttribute('data-one-way') === 'true';
      var isCollapsed = trigger.getAttribute('data-collapsed') === 'true';

      if (isOneWay) {
        // Already triggered once -- inert from here on, never toggles back.
        if (!isCollapsed) {
          return;
        }
        trigger.setAttribute('data-collapsed', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        trigger.setAttribute('tabindex', '-1');
        if (ownSection) {
          // Same transition timing as the sibling reveal below, so this row
          // reads as being replaced by the content appearing under it.
          ownSection.setAttribute('data-one-way-done', 'true');
        }
        return;
      }

      trigger.setAttribute('data-collapsed', isCollapsed ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
    }

    trigger.addEventListener('click', activate);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        activate();
      }
    });
  });
});
